@use "styles" as *;

$block: me-portal-header;

.#{$block} {
  display: flex;
  flex-direction: column;
  box-shadow: $box-shadow;

  @include hide-on-print;

  &__upper {
    display: flex;
    padding: space(3, 4);
    background: $color-gray-100;
    font-size: $font-size-s;

    & .#{$block}__body {
      justify-content: space-between;

      @include media-breakpoint-down(sm) {
        justify-content: center;
      }
    }
  }

  &__date {
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  &__lower {
    padding: space(8, 4, 4);
    background: $color-background-contrast;
  }

  &__body {
    display: flex;
    width: 100%;
    max-width: $container-max-width;
    margin: auto;
  }
}
